import { Routes } from '@angular/router';
import { HomeProfissionaisComponent } from './components/profissionais/home-profissionais/home-profissionais.component';
import { CadastrarProfissionaisComponent } from './components/profissionais/cadastrar-profissionais/cadastrar-profissionais.component';
import { HomeVagasComponent } from './components/vagas/home-vagas/home-vagas.component';
import { CadastrarVagasComponent } from './components/vagas/cadastrar-vagas/cadastrar-vagas.component';
import { ListaCandidaturasComponent } from "./components/candidaturas/lista-candidaturas/lista-candidaturas.component";
import { HomeEmpresasComponent } from './components/empresas/home-empresas/home-empresas.component';
// import { CadastrarEmpresaComponent } from "./components/empresas/cadastrar-empresa/cadastrar-empresa.component";
import { CandidaturaDetalheComponent } from './components/candidaturas/candidatura-detalhe/candidatura-detalhe.component';
import { DetalheEmpresaComponent } from './components/empresas/detalhe-empresa/detalhe-empresa.component';
import { AddRepresentanteComponent } from './components/empresas/representantes/representante-form/add-representante.component';
import { DetalheVagaComponent } from './components/vagas/detalhe-vaga/detalhe-vaga.component';

export const profissionaisRoutes: Routes = [
  {
    path: 'profissionais',
    children: [
      {
        path: '',
        pathMatch: 'full',
        component: HomeProfissionaisComponent,
      },
      {
        path: 'cadastro',
        component: CadastrarProfissionaisComponent,
      },
    ],
  },
  {
    path: 'vagas',
    children: [
      {
        path: '',
        pathMatch: 'full',
        component: HomeVagasComponent,
      },
      {
        path: 'cadastrar',
        component: CadastrarVagasComponent,
      },
      {
        path: 'detalhe-vaga/:id',
        component: DetalheVagaComponent,
      },
    ],
  },
  {
    path: 'candidaturas',
    children: [
      {
        path: '',
        pathMatch: 'full',
        component: ListaCandidaturasComponent,
      },
      {
        path: ':id',
        component: CandidaturaDetalheComponent,
      },
    ],
  },
  {
    path: 'empresas',
    children: [
      {
        path: '',
        pathMatch: 'full',
        component: HomeEmpresasComponent,
      },
      // {
      //     path: 'cadastrar',
      //     component: CadastrarEmpresaComponent
      // },
      {
        path: 'add-representante/:id',
        component: AddRepresentanteComponent,
      },
      {
        path: 'detalhe-empresa/:id',
        component: DetalheEmpresaComponent,
      },
    ],
  },
];
